module.exports = __webpack_public_path__ + "static/media/icon9.2ccdfc7a.svg";